import { combineReducers, Action } from "redux";
import { routerReducer, RouterState } from "react-router-redux";
import postArticles, { PostArticlesState } from "./post_articles/reducer";

export type RootState = {
  post_articles: PostArticlesState;
  router: RouterState;
};

const generateReducer = () => {
  const combinedReducer = combineReducers<RootState>({
    post_articles: postArticles,
    router: routerReducer,
  });

  return (prevState: RootState, action: Action) => {
    let state = combinedReducer(prevState, action);
    return state;
  };
};
export default generateReducer;



// WEBPACK FOOTER //
// ./frontend/src/generateReducer.ts